import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './utils/axiosRequest'
import { Message } from 'element-ui'
import './common/font.css'
import VideoPlayer from 'vue-video-player'
import 'wowjs/css/libs/animate.css'
// import 'animate.css'
import preventReClick from './utils/preventReClick'
import moment from 'moment'
Vue.prototype.$moment = moment
import wow from 'wowjs'
import * as echarts from 'echarts'
import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '1147291d80783291a3a95280a2a22a8e',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
Vue.prototype.$echarts = echarts //挂载到Vue实例上面

Vue.prototype.$wow = wow
Vue.use(preventReClick)
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
Vue.use(ElementUI)
Vue.config.productionTip = false
// 浏览器标题
// Vue.directive('title', {
//   inserted: function (el, binding) {
//     document.title = el.dataset.title
//   }
// })

router.beforeEach(async (to, from, next) => {

  // await store.dispatch('checkToken')
  // console.log('to', to, 'from', from, 'next', next)
  // if (from.fullPath) {
  // }
  if (to.name) {
    // store.commit('httpsURL',window.location.host+'/')
    store.commit('httpsURL', 'http://123.56.170.62:8888/')
    store.commit('httpsURL1','http://123.56.170.62:443/')
  next()
  } else {
    // await store.dispatch("checkToken");
    let s = setTimeout(() => {
      if (store.state.isLogin) {
        next()
      } else {
         Message({
            message: '请登录！',
              type: 'error'
            })
        next({ path: "/Home" })

      }
      clearTimeout(s)
    }, 400);
  }
  if (Object.keys(axios.queue).length > 0) {
    Object.keys(axios.queue).forEach(key => {
      axios.queue[key]('请求中断~')
      delete axios.queue[key]
    })
  }
})
// router.beforeEach((to, from, next) => {
// alert(to, from, next)
// 获取用户登录成功后储存的登录标志
// const getFlag = localStorage.getItem('token')
// // 如果登录标志存在且为isLogin，即用户已登录
// if (getFlag === 'isLogin') {
//   // 设置vuex登录状态为已登录
//   store.state.isLogin = true
//   next()

//   // 如果已登录，还想想进入登录注册界面，则定向回首页
//   if (!to.meta.isLogin) {
//     // iViewUi友好提示
//     // iView.Message.error('请先退出登录')
//     next({
//       path: '/home'
//     })
//   }

// // 如果登录标志不存在，即未登录
// } else {
//   // 用户想进入需要登录的页面，则定向回登录界面
//   if (to.meta.isLogin) {
//     next({
//       path: '/login'
//     })
//     // iViewUi友好提示

//   // 用户进入无需登录的界面，则跳转继续
//   } else {
//     next()
//   }
// }
// })

// Vue.directive('demo', Opt)
Vue.prototype.$axios = axios // 添加axios到Vue的原型对象上
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
